import 'babel-polyfill';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer } from 'react-toastify';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import { store, history } from './Store';
import './Style/App.scss';
import { MATOMO_ENABLED, MATOMO_BASE_URL, MATOMO_SITE_ID } from './Constants';
import Routes from './Routes';

import ErrorBoundary from './Components/ErrorBoundary';

require('what-input');

let matomoInstance;

if (MATOMO_ENABLED) {
  matomoInstance = createInstance({
    urlBase: MATOMO_BASE_URL,
    siteId: MATOMO_SITE_ID,
    linkTracking: false,
  });
}

class App extends Component {
  render() {
    return (
      <div>
        {MATOMO_ENABLED ? (
          <MatomoProvider value={matomoInstance}>
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <div className="root-wrapper">
                  <ErrorBoundary>
                    <Routes />
                    <ToastContainer autoClose={2500} />
                  </ErrorBoundary>
                </div>
              </ConnectedRouter>
            </Provider>
          </MatomoProvider>
        ) : (
          <Provider store={store}>
            <ConnectedRouter history={history}>
              <div className="root-wrapper">
                <ErrorBoundary>
                  <Routes />
                  <ToastContainer autoClose={2500} />
                </ErrorBoundary>
              </div>
            </ConnectedRouter>
          </Provider>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js